<template>
	<main class="not-found">
		<div class="not-found__inner _cnt">
			<div class="not-found__title _h2">
				{{ $t("Unfortunately couldn't find the page") }}
			</div>
		</div>
	</main>
</template>
<script>
import { ButtonThemes } from '@/components/base/BaseButton.vue';

export default {
	name: 'PageNotFound',
	components: {},
	props: [],
	data: function () {
		return {
			ButtonThemes,
		};
	},
	methods: {},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.not-found {
	@include header-indent;
	@include adaptiveValue('padding-top', 50, 25);
	@include adaptiveValue('padding-bottom', 50, 20);
	&__inner {
		@media (min-width: $md5) {
			display: flex;
			flex-wrap: wrap;
			gap: 20px;
		}
	}
	&__title {
		text-align: center;
		display: block;
		margin: 0 auto;
	}
}
</style>
